<template>
  <div
    v-click-outside="onClickOutside"
    class="base-dropdown-select"
  >
    <base-dropdown
      :label="label"
      :active="isOpen"
      @click="toggleDropdown"
    />
    <transition name="fade">
      <div
        v-if="isOpen"
        class="base-dropdown-select__popover"
      >
        <div
          v-for="(item, index) in items"
          :key="`base-dropdown-select-${index}`"
          class="base-dropdown-select__popover__item"
          :style="`${value === index ? 'background-color: #F0F0F0;' : '' } `"
          @click="$emit('input', index)"
        >
          <base-text
            style="align-self: center;"
            size="md"
          >
            {{ item }}
          </base-text>
          <div class="base-dropdown-select__popover__icon">
            <base-icon v-if="value === index" icon="check" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'BaseDropdownSelect',
  props: {
    label: {
      type: String,
      required: false,
      default: null,
    },
    items: {
      type: Array,
      required: true,
    },
    value: {
      type: Number,
      default: null,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    onClickOutside() {
      if (this.isOpen && !this.persistent) this.isOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.base-dropdown-select {
  position: relative;
  &__popover {
    margin-top: 7px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    border-radius: 5px;
    background-color: white;
    z-index: 10;
    position: absolute;
    right: 0;
    display: flex;
    flex-direction: column;
    &__item {
      justify-content: space-between;
      display: inline-flex;
      cursor: pointer;
      align-content: center;
      width: 180px;
      height: 35px;
      padding: 0px 10px 0px 10px;
      // & + & {
      // }
    }
    &__item:hover{
        background-color: #F0F0F0;
      }

    &__icon {
      width: 15px;
      height: 15px;
      display: flex;
      align-self: center;
      padding: 1x 9px 3px 0;
    }
  }
}
</style>
